module.exports = pratt.PrattSharedLibs.instantsearch.widgets;